import SelectHorsesSection from './SelectHorsesSection';

export default SelectHorsesSection;
